<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container">
    <ul class="nav navbar-nav">
      <li class="item">
        <router-link to="/join-us/market" :class="{active: nav('market')}">市场</router-link>
      </li>
      <li class="item">
        <router-link to="/join-us/opearte">运营</router-link>
      </li>
      <li class="item">
        <router-link to="/join-us/research">研发</router-link>
      </li>
      <li class="item">
        <router-link to="/join-us/preduce">产品</router-link>
      </li>
      <li class="item">
        <router-link to="/join-us/administration">行政</router-link>
      </li>
      <li class="item">
        <router-link to="/join-us/personnel">人事</router-link>
      </li>
      <li class="contact">
              <span class="item-a">
                <img src="../../../../static/img/join_us/mail.png"/>
              <span><a class="mail text">简历请发送至邮箱：HR@EMULIAN.COM</a></span>
              </span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'homeJoinNavi',
    methods: {
      nav: function (str) {
        return this.$route.name === str
      }
    }
  }
</script>

<style scoped>
  .container {
    width: 1100px;
    margin: auto;
    padding: 40px 0;
  }
  .nav>li>a {
    padding: 16px 25px;
  }
  ul {
    border-bottom: solid;
    border-color: rgb(249, 136, 3);
    border-width: 4px;
    padding: 0;
    margin: 0;
  }

  .navbar-nav > li {
    font-size: 18px;
    font-family: Helvetica-Bold, "Helvetica Bold", Helvetica;
    font-weight: 700;
    font-style: normal;
    color: rgb(73, 73, 73);
    margin: 0;
  }

  .nav > li > a:focus, .nav > li > a:hover {
    text-decoration: none;
    color: rgb(255, 255, 255);
    background-color: rgb(249, 136, 3);
  }

  .navbar-nav > li > a:focus, .navbar-default .navbar-nav > li > a:hover {
    color: rgb(255, 255, 255);
    background-color: rgb(249, 136, 3);
  }

  .navbar-nav {
    float: none;
  }

  .active {
    background-color: rgb(249, 136, 3);
    color: rgb(255, 255, 255);
  }

  li {
    padding: 0;
    margin: 0;
  }

  .item {
    font-size: 18px;
    font-family: Helvetica-Bold, "Helvetica Bold", Helvetica;
    font-weight: 700;
    font-style: normal;
    color: rgb(73, 73, 73)
  }

  .item:hover {
    color: rgb(249, 136, 3);
    background-color: rgb(242, 242, 242);
  }

  .nav > li, .navbar-nav > li {
    padding: 0;
    margin: 0;
  }

  .mail {
    text-decoration: none;
    color: rgb(58, 152, 251);
    font-size: 18px;
    font-weight: 400;
    font-style: normal;
    font-family: 'ArialMT', 'Arial';
  }

  .contact {
    height: 52px;
    align-items: center;
    display: flex;
    float: right;
  }

  span {
    font-family: 'PingFangSC-Regular', 'PingFang SC';
    font-size: 16px;
  }

  a {
    color: rgb(73, 73, 73);
    text-decoration: none;
    margin: 0;
    padding: 0;
  }

  /*.text {*/
  /*}*/

</style>



// WEBPACK FOOTER //
// HomeJoinNavi.vue?5f1e7514